module.exports = "/assets/2b3510c2f18b30775dc0f81324682f93.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/LH.png
// module id = 2703
// module chunks = 0